import React, { Component } from "react";
import { Link } from "react-router-dom";
import BottomBar from "../../components/navbar/BottomBar.js";
import { Flex } from "../../styles/GlobalStyle.js";
import {
  TitleOrder,
  TitleProduct,
  SubTitleProduct,
  TagPrice,
  TotalPrice,
  Button,
  Container,
  ButtonQuantity,
  TextQuantity,
} from "./style/BasketStoreStyle.js";
import ButtonComponent from "../../components/Button";
import Selector from "../../components/Selector";
import "react-responsive-modal/styles.css";
import ConfirmationModal from "../../components/modal/ConfirmationModal";
import ConfirmOrderAskRoomLastNameModal from "../../components/modal/ConfirmOrderAskRoomLastNameModal";
import TopBar from "../../components/navbar/TopBar";
import TokenService from "../../backend/TokenService";
import Property from "../../model/property";
import AddCircle from "@material-ui/icons/AddCircle";
import RemoveCircle from "@material-ui/icons/RemoveCircle";
import CloseIcon from "@material-ui/icons/Close";
import ErrorModal from "../../components/modal/ErrorModal";
import FillRequiredModal from "../../components/modal/FillRequiredModal";
import SimpleModal from "../../components/modal/SimpleModal";
import { withTranslation } from "react-i18next";
import {
  find,
  isEmpty,
  isUndefined,
  get,
  replace,
  filter,
  isNull,
} from "lodash";
import moment from "moment";
import LoadingScreen from "../../components/LoadingScreen";
import PaymentMethod from "../../components/PaymentMethod";
import PaymentService from "../../backend/PaymentService.js";
import { TopPadding } from "../categories/Style";

const FulfillmentService = require("../../backend/FulfillmentService");
const ReservationService = require("../../backend/ReservationService");

async function getFulfillmentPrices(storeUid, type, products, options = []) {
  const k = Property.getExpireKey();
  let response = await FulfillmentService.getPrices(
    storeUid,
    type,
    products,
    options,
    k
  );
  return response.data;
}

function setHomeGlobalBackgroundColor(presets) {
  if (presets) {
    if (!isEmpty(presets.app_webstore_favicon_url)) {
      const favicon = document.getElementById("favicon");
      if (favicon) favicon.href = presets.app_webstore_favicon_url;
      const appleFavicon = document.getElementById("apple-favicon");
      if (appleFavicon) appleFavicon.href = presets.app_webstore_favicon_url;
    }
    const desktopContainer = document.getElementById("desktop-container");
    if (desktopContainer) {
      if (!isEmpty(presets.app_home_webapp_desktop_bg)) {
        desktopContainer.style.backgroundColor =
          presets.app_home_webapp_desktop_bg;
      }
    }
    const root = document.getElementById("root");
    const tabletContainer = document.getElementById("tablet-container");
    const wrapper = tabletContainer ? tabletContainer : root;

    if (wrapper) {
      if (!isEmpty(presets.app_home_global_background_color)) {
        wrapper.style.backgroundColor =
          presets.app_home_global_background_color;
      }
    }
  }
}

async function getAdyenSessionData(
  storeUid,
  type,
  products,
  options = [],
  returnUrl,
  roomNumber,
  lastName,
  accessToken,
  noteItemSelection
) {
  const k = Property.getExpireKey();
  let response = await FulfillmentService.createAdyenSession(
    storeUid,
    type,
    products,
    k,
    options,
    returnUrl,
    lastName,
    roomNumber,
    accessToken,
    noteItemSelection
  );
  return response.data;
}

async function postFulfillmentOrders(
  storeUid,
  type,
  products,
  expireKey,
  notes,
  notesSelectionOptions,
  lastName,
  roomNumber,
  language,
  accessToken,
  platform,
  deviceType,
  paymentId,
  paymentSelected,
  autoReminder = null,
  options = []
) {
  let response = await FulfillmentService.postOrders(
    storeUid,
    type,
    products,
    expireKey,
    notes,
    notesSelectionOptions,
    lastName,
    roomNumber,
    language,
    accessToken,
    platform,
    deviceType,
    paymentId,
    paymentSelected,
    autoReminder,
    options
  );
  return response.data;
}

class BasketStore extends Component {
  state = {
    navbarOpen: false,
    products: [],
    showConfirmation: false,
    totalFinalPrice: 0,
    total: 0,
    subtotal: 0,
    extraCharges: [],
    lastExtraCharges: [],
    edit: false,
    loading: false,
    okDisabled: false,
    hasError: false,
    addedPrice: {},
    checkValidation: false,
    requiredField: false,
    placeOrderCheck: false,
    itemSelection: "",
    lastName: "",
    roomNumber: "",
    getPriceErrorMessage: "",
    postOrderErrorMessage: "",
    dateTimeErrorMessage: "",
    WarningMessage: "",
    preset: {},
    disabledBottomBar: true,
    arraySelector: [],
    selectionOptions: [],
    roomUser: false,
    noticePaymentMethod: false,
    enableInventoryManagement: false,
    fulfillmentTypeName: "",
    propertyUid: "",
    storeUid: "",
    showEmptyBasket: false,
    redirectAfterError: false,
  };

  handlerPreviousMenu = (e) => {
    e.preventDefault();
    Property.popPreviousTitle();
    this.props.history.goBack();
  };

  handlerPaymentMethod = (item) => {
    Property.setPaymentSelected(item);
    this.setState({ noticePaymentMethod: false });
  };

  showModal = () => {
    if (this.state.okDisabled || this.state.loading) {
      return;
    }
    if (Property.getCartItem().length === 0) {
      this.setState({ showEmptyBasket: true });
      return;
    }
    if (
      Property.getStoreInterfaceType() === "adyen" &&
      isNull(Property.getPaymentSelected())
    ) {
      this.setState({ noticePaymentMethod: true });
      return;
    }
    let itemSelection = "";
    let selectionOptions = [];
    let validateDataInput = true;
    let hasError = false;

    this.setState({
      checkValidation: true,
    });

    this.updateBasket();
    for (let i = 0; i < this.state.arraySelector.length; i++) {
      const selectionType = this.state.arraySelector[i].selection_type;
      const shouldSetValueAsText =
        selectionType === "pick_date" ||
        selectionType === "pick_time" ||
        selectionType === "pick_time_relative" ||
        selectionType === "pick_date_and_time" ||
        selectionType === "pick_date_and_static_time" ||
        selectionType === "pick_date_spa_booker" ||
        selectionType === "pick_number" ||
        selectionType === "text_input" ||
        selectionType === "email_input" ||
        selectionType === "signature" ||
        selectionType === "fixed_inventory_selection";

      if (shouldSetValueAsText) {
        selectionOptions.push({
          id: this.state.arraySelector[i].id,
          type: selectionType,
          index: i,
          values: [{ value: this.state.arraySelector[i].values || "-" }],
        });
      } else if (selectionType === "pick_product_price") {
        selectionOptions.push({
          id: this.state.arraySelector[i].id,
          type: selectionType,
          index: i,
          values: this.state.arraySelector[i].values,
        });
      } else {
        selectionOptions.push({
          id: this.state.arraySelector[i].id,
          type: selectionType,
          index: i,
          values: filter(this.state.arraySelector[i].values, { select: true }),
        });
      }

      if (shouldSetValueAsText) {
        if (selectionType === "pick_date_and_time") {
          if (
            moment(this.state.arraySelector[i].values).valueOf() + 60000 <
            moment().valueOf()
          ) {
            hasError = true;
            this.setState({
              hasError: true,
              showConfirmation: false,
              dateTimeErrorMessage: `${this.props.t(
                "DATE_TIME_ERROR_MESSAGE"
              )}`,
            });
            break;
          }
        }

        itemSelection +=
          this.state.arraySelector[i].title +
          ": " +
          (this.state.arraySelector[i].values || "-") +
          "\n";
        if (this.state.arraySelector[i].force_input) {
          if (!this.state.arraySelector[i].values) {
            validateDataInput = false;
            break;
          }
        }
      }

      if (selectionType === "pick_one" || selectionType === "pick_one_price" || selectionType === "pick_table_dropdown") {
        itemSelection += this.state.arraySelector[i].title + ": ";
        let pickOneValid = false;
        for (let l = 0; l < this.state.arraySelector[i].values.length; l++) {
          if (this.state.arraySelector[i].values[l].select) {
            if (selectionType === "pick_one_price") {
              itemSelection +=
                this.state.arraySelector[i].values[l].name +
                " (+" +
                this.state.arraySelector[i].values[l].price +
                ")\n";
            }

            if (selectionType === "pick_one" || selectionType === "pick_table_dropdown") {
              itemSelection +=
                this.state.arraySelector[i].values[l].name + "\n";
            }
          }

          if (this.state.arraySelector[i].force_input) {
            if (this.state.arraySelector[i].values[l].select === true) {
              pickOneValid = true;
              break;
            }
          }
        }
        if (this.state.arraySelector[i].force_input && !pickOneValid) {
          validateDataInput = false;
          break;
        }
      }

      if (
        selectionType === "pick_multiple" ||
        selectionType === "pick_multiple_price"
      ) {
        itemSelection += this.state.arraySelector[i].title + ": ";
        let pickMultipleValid = false;
        for (let k = 0; k < this.state.arraySelector[i].values.length; k++) {
          if (this.state.arraySelector[i].values[k].select) {
            if (selectionType === "pick_multiple_price") {
              itemSelection +=
                this.state.arraySelector[i].values[k].name +
                " (+" +
                this.state.arraySelector[i].values[k].price +
                ")";
            }

            if (selectionType === "pick_multiple") {
              itemSelection +=
                this.state.arraySelector[i].values[k].name + ", ";
            }
          }
        }

        for (let k = 0; k < this.state.arraySelector[i].values.length; k++) {
          if (this.state.arraySelector[i].force_input) {
            if (this.state.arraySelector[i].values[k].select === true) {
              pickMultipleValid = true;
              break;
            }
          }
        }

        itemSelection += "\n";
        if (this.state.arraySelector[i].force_input && !pickMultipleValid) {
          validateDataInput = false;
          break;
        }
      }

      if (selectionType === "pick_dropdown") {
        const dataSelected = find(this.state.arraySelector[i].values, {
          select: true,
        });
        itemSelection += `${this.state.arraySelector[i].title}: ${get(
          dataSelected,
          "name",
          ""
        )}\n`;
        if (
          this.state.arraySelector[i].force_input &&
          isUndefined(dataSelected)
        ) {
          validateDataInput = false;
          break;
        }
      }
    }

    // checks whether the email checkout option is present and if it is invalid
    if (
      Property.getInputEmail() !== null &&
      String(Property.getInputEmail())
        .toLowerCase()
        .match(
          /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/
        ) === null
    ) {
      validateDataInput = false;
    }
    if (!validateDataInput) {
      this.setState({ requiredField: true });
    } else if (hasError) {
    } else {
      this.setState({
        showConfirmation: !this.state.showConfirmation,
        itemSelection,
        selectionOptions,
      });
      Property.setNoteItemSelection(itemSelection);
    }
  };

  saveSpot = async () => {
    if (this.state.okDisabled || this.state.loading) {
      return;
    }
    if (Property.getCartItem().length === 0) {
      this.setState({ showEmptyBasket: true });
      return;
    }
    if (
      Property.getStoreInterfaceType() === "adyen" &&
      isNull(Property.getPaymentSelected())
    ) {
      this.setState({ noticePaymentMethod: true });
      return;
    }
    let itemSelection = "";
    let selectionOptions = [];
    let validateDataInput = true;
    let hasError = false;

    this.setState({
      checkValidation: true,
    });

    this.updateBasket();
    for (let i = 0; i < this.state.arraySelector.length; i++) {
      const selectionType = this.state.arraySelector[i].selection_type;
      const shouldSetValueAsText =
        selectionType === "pick_date" ||
        selectionType === "pick_time" ||
        selectionType === "pick_time_relative" ||
        selectionType === "pick_date_and_time" ||
        selectionType === "pick_date_and_static_time" ||
        selectionType === "pick_date_spa_booker" ||
        selectionType === "pick_number" ||
        selectionType === "text_input" ||
        selectionType === "email_input" ||
        selectionType === "signature" ||
        selectionType === "fixed_inventory_selection";

      if (shouldSetValueAsText) {
        selectionOptions.push({
          id: this.state.arraySelector[i].id,
          type: selectionType,
          index: i,
          values: [{ value: this.state.arraySelector[i].values || "-" }],
        });
      } else if (selectionType === "pick_product_price") {
        selectionOptions.push({
          id: this.state.arraySelector[i].id,
          type: selectionType,
          index: i,
          values: this.state.arraySelector[i].values,
        });
      } else {
        selectionOptions.push({
          id: this.state.arraySelector[i].id,
          type: selectionType,
          index: i,
          values: filter(this.state.arraySelector[i].values, { select: true }),
        });
      }

      if (shouldSetValueAsText) {
        if (selectionType === "pick_date_and_time") {
          if (
            moment(this.state.arraySelector[i].values).valueOf() + 60000 <
            moment().valueOf()
          ) {
            hasError = true;
            this.setState({
              hasError: true,
              showConfirmation: false,
              dateTimeErrorMessage: `${this.props.t(
                "DATE_TIME_ERROR_MESSAGE"
              )}`,
            });
            break;
          }
        }

        itemSelection +=
          this.state.arraySelector[i].title +
          ": " +
          (this.state.arraySelector[i].values || "-") +
          "\n";
        if (this.state.arraySelector[i].force_input) {
          if (!this.state.arraySelector[i].values) {
            validateDataInput = false;
            break;
          }
        }
      }

      if (selectionType === "pick_one" || selectionType === "pick_one_price" || selectionType === "pick_table_dropdown") {
        itemSelection += this.state.arraySelector[i].title + ": ";
        let pickOneValid = false;
        for (let l = 0; l < this.state.arraySelector[i].values.length; l++) {
          if (this.state.arraySelector[i].values[l].select) {
            if (selectionType === "pick_one_price") {
              itemSelection +=
                this.state.arraySelector[i].values[l].name +
                " (+" +
                this.state.arraySelector[i].values[l].price +
                ")\n";
            }

            if (selectionType === "pick_one" || selectionType === "pick_table_dropdown") {
              itemSelection +=
                this.state.arraySelector[i].values[l].name + "\n";
            }
          }

          if (this.state.arraySelector[i].force_input) {
            if (this.state.arraySelector[i].values[l].select === true) {
              pickOneValid = true;
              break;
            }
          }
        }
        if (this.state.arraySelector[i].force_input && !pickOneValid) {
          validateDataInput = false;
          break;
        }
      }

      if (
        selectionType === "pick_multiple" ||
        selectionType === "pick_multiple_price"
      ) {
        itemSelection += this.state.arraySelector[i].title + ": ";
        let pickMultipleValid = false;
        for (let k = 0; k < this.state.arraySelector[i].values.length; k++) {
          if (this.state.arraySelector[i].values[k].select) {
            if (selectionType === "pick_multiple_price") {
              itemSelection +=
                this.state.arraySelector[i].values[k].name +
                " (+" +
                this.state.arraySelector[i].values[k].price +
                ")";
            }

            if (selectionType === "pick_multiple") {
              itemSelection +=
                this.state.arraySelector[i].values[k].name + ", ";
            }
          }
        }

        for (let k = 0; k < this.state.arraySelector[i].values.length; k++) {
          if (this.state.arraySelector[i].force_input) {
            if (this.state.arraySelector[i].values[k].select === true) {
              pickMultipleValid = true;
              break;
            }
          }
        }

        itemSelection += "\n";
        if (this.state.arraySelector[i].force_input && !pickMultipleValid) {
          validateDataInput = false;
          break;
        }
      }

      if (selectionType === "pick_dropdown") {
        const dataSelected = find(this.state.arraySelector[i].values, {
          select: true,
        });
        itemSelection += `${this.state.arraySelector[i].title}: ${get(
          dataSelected,
          "name",
          ""
        )}\n`;
        if (
          this.state.arraySelector[i].force_input &&
          isUndefined(dataSelected)
        ) {
          validateDataInput = false;
          break;
        }
      }
    }

    // checks whether the email checkout option is present and if it is invalid
    if (
      Property.getInputEmail() !== null &&
      String(Property.getInputEmail())
        .toLowerCase()
        .match(
          /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/
        ) === null
    ) {
      validateDataInput = false;
    }
    if (!validateDataInput) {
      this.setState({ requiredField: true });
    } else if (hasError) {
    } else {
      this.setState({
        itemSelection,
        selectionOptions,
      });
      Property.setNoteItemSelection(itemSelection);
      await this.onConfirm();
    }
  };

  componentDidMount() {
    window.scrollTo(0, 0);
    var products = [];
    var totalFinalPrice = 0;
    let cartItem = Property.getCartItem();
    const options = Property.getBasketOptions();
    for (const item of cartItem) {
      const countedPrice = (item.price_options && item.price_options.length > 0) ? item.item_price : item.item_quantity * item.item_price;
      let product = {
        id: item.uid,
        title: item.item_name,
        quantity: item.item_quantity,
        price: item.item_price,
        subtitle: item.item_subtitle,
        totalPrice: countedPrice,
        item_selection: item.item_selection,
        unpaired_available: item.unpaired_available,
        category_unpaired_available: item.category_unpaired_available,
        price_options: item.price_options,
        selection_options: item.selection_options,
        updatedAt: item.updatedAt,
      };
      totalFinalPrice += countedPrice;
      products.push(product);
    }
    const property = Property.getData();
    const configuration = Property.getConfiguration(property.uid);
    const enableInventoryManagement = get(
      configuration,
      "preset_config.enable_inventory_management",
      false
    );
    this.setState({
      products: products,
      placeOrderCheck: !!(products && products.length > 0),
      totalFinalPrice: totalFinalPrice,
      enableInventoryManagement: enableInventoryManagement,
      fulfillmentTypeName: get(property, "store.fulfillment_type_name"),
      propertyUid: property.uid,
      storeUid: get(property, "store.uid"),
    });

    let arraySelector = [];
    for (let i = 0; i < options.length; i++) {
      const newData = {};
      const data = options[i];
      for (const key in data) {
        if (!data[key] && data[key] !== 0) {
          continue;
        }
        newData[key] = data[key];
        if (key === "values") {
          // data.values && data.values.length > 0
          const newValues = [];
          for (let z = 0; z < data.values.length; z++) {
            // @ts-ignore
            const newData2 = {};
            const node = data.values[z];
            for (const key2 in node) {
              if (!node[key2] && node[key2] !== 0) {
                continue;
              }
              newData2[key2] = node[key2];
            }
            if (["pick_one", "pick_one_price", "pick_table_dropdown"].includes(data.selection_type)) {
              newData2.select = z.toString() === data.default;
            } else {
              newData2.select = newData2.default === "true";
            }

            if (data.selection_type === "pick_multiple_price") {
              newData2.select = !!newData2.default;
            }

            if (data.selection_type === "pick_multiple") {
              newData2.select = !!newData2.default;
            }

            if (data.selection_type === "pick_dropdown") {
              newData2.select = data.default === newData.id;
            }
            newValues.push(newData2);
          }
          newData[key] = newValues;
        }
      }
      arraySelector.push(newData);
    }

    const arraySelectionOption = Property.getArraySelectionOption();
    let currentArraySelector;
    if (
      arraySelectionOption.length === 0 ||
      arraySelectionOption.length !== arraySelector.length
    ) {
      Property.setArraySelectionOption(arraySelector);
      currentArraySelector = arraySelector;
    } else {
      currentArraySelector = arraySelectionOption;
    }
    this.setState({ arraySelector: currentArraySelector });

    let { uid, type } = Property.getOrderInfo();
    let orderProducts = products.map((product) => {
      return {
        uid: product.id,
        quantity: product.quantity,
        updated_at: product.updatedAt,
        price_options: product.price_options,
      };
    });
    const payment = Property.getPayment();
    if (isNull(payment)) {
      if (orderProducts.length !== 0) {
        getFulfillmentPrices(
          uid,
          type,
          orderProducts,
          this.orderSelectedPickOptions(currentArraySelector)
        )
          .then(
            function (result) {
              if (result && result.error_message) {
                this.setState({
                  hasError: true,
                  getPriceErrorMessage: result.error_message,
                });
              } else {
                const total = result.total;
                const subtotal = result.subtotal;
                const extraCharges = result.extra_charges;
                const roomUser = result.room;
                this.setState({
                  extraCharges,
                  total,
                  subtotal,
                  lastExtraCharges: result.last_extra_charges,
                  getPriceErrorMessage: "",
                  disabledBottomBar: false,
                  roomUser,
                  loading: false,
                  hasError: result.force_update,
                  WarningMessage: result.force_update
                    ? this.props.t("WARNING_MESSAGE_UPDATE_PRODUCT")
                    : "",
                });
              }
            }.bind(this)
          )
          .catch(() => {
            this.setState({
              hasError: true,
              showConfirmation: false,
              getPriceErrorMessage: `${this.props.t("NETWORK_ERROR")}`,
            });
          });
      }
    } else {
      this.onConfirm();
    }

    const location = this.props.location;
    const productUrl = replace(
      get(location, "pathname", ""),
      "basket",
      "products"
    );
    if (productUrl) {
      Property.setProductURL(productUrl);
    }
  }

  componentDidUpdate() {
    if (isEmpty(this.state.preset) && !isUndefined(Property.getPreset())) {
      const presets = Property.getPreset();
      setHomeGlobalBackgroundColor(presets);
      this.setState({ preset: presets });
    }
  }

  refreshArraySelector(data, id) {
    let value = 0;
    if (data && data.selection_type === "pick_one_price") {
      for (const i in data.values) {
        if (data.values[i].select === true) {
          value = data.values[i].price;
        }
      }
    }

    if (data && data.selection_type === "pick_multiple_price") {
      for (const i in data.values) {
        if (data.values[i].select === true) {
          value = value + data.values[i].price;
        }
      }
    }
    if (data && data.selection_type === "pick_product_price") {
      for (const i in data.values) {
        value = value + data.values[i].price * data.values[i].value;
      }
    }

    const pickPricesClone = this.state.addedPrice;

    pickPricesClone[id] = value;
    this.setState({
      addedPrice: pickPricesClone,
    });
    this.updateBasket();
  }

  setProducts = () => {
    let products = [];
    let totalFinalPrice = 0;
    let cartItem = Property.getCartItem();
    for (const item of cartItem) {
      const countedPrice = (item.price_options && item.price_options.length > 0) ? item.item_price : item.item_quantity * item.item_price;
      let product = {
        id: item.uid,
        title: item.item_name,
        quantity: item.item_quantity,
        price: item.item_price,
        subtitle: item.item_subtitle,
        totalPrice: countedPrice,
        item_selection: item.item_selection,
        unpaired_available: item.unpaired_available,
        category_unpaired_available: item.category_unpaired_available,
        selection_options: item.selection_options,
        updatedAt: item.updatedAt,
      };
      if (!isEmpty(item.price_options)) {
        product = { ...product, price_options: item.price_options };
      }
      totalFinalPrice += countedPrice;
      products.push(product);
    }
    this.setState({
      products: products,
      placeOrderCheck: !!(products && products.length > 0),
      totalFinalPrice: totalFinalPrice,
    });
  };

  editCart(hint, id, itemSelection) {
    Property.editQuantityCartItems(hint, id, itemSelection);
    this.setProducts();
  }

  removeItem = (uid, itemSelection) => {
    Property.removeCartItems(uid, itemSelection);
    this.setProducts();
  };

  doNothing = () => {};

  onChange = (key, val) => {
    this.setState({
      [key]: val,
    });
  };

  hotelKeyStatus = (accessToken, jobId, email) => {
    if (jobId && email && accessToken) {
      PaymentService.getHotelKeyPaymentLinkStatus(accessToken, jobId, email)
        .then((response) => {
          if (
            ["finished", "received"].includes(
              get(response.data, "status").toLowerCase()
            )
          ) {
            Property.setHotelkeyPaymentLink(response.data);
            this.props.history.push("/hotelkey-payment");
          } else if (get(response.data, "status") === "failed") {
            const error = get(response.data, "error");
            this.setState({
              hasError: true,
              loading: false,
              okDisabled: false,
              showConfirmation: false,
              getPriceErrorMessage: error,
            });
          } else {
            setTimeout(() => {
              this.hotelKeyStatus(accessToken, jobId, email);
            }, 3000); // set timer to call the booking api
          }
        })
        .catch((error) => {
          console.error(error);
          this.setState({
            hasError: true,
            loading: false,
            okDisabled: false,
            showConfirmation: false,
            getPriceErrorMessage:
              get(error.response, "data.error") ||
              `${this.props.t("NETWORK_ERROR")}`,
          });
          throw error;
        });
    }
  };

  getAllProducts = () => {
    let products = [];
    const cartItem = Property.getCartItem();
    for (const item of cartItem) {
      const countedPrice = item.item_quantity * item.item_price;
      let product = {
        id: item.uid,
        title: item.item_name,
        quantity: item.item_quantity,
        price: item.item_price,
        subtitle: item.item_subtitle,
        totalPrice: countedPrice,
        item_selection: item.item_selection,
        unpaired_available: item.unpaired_available,
        category_unpaired_available: item.category_unpaired_available,
        price_options: item.price_options,
        selection_options: item.selection_options,
        updatedAt: item.updatedAt,
      };
      products.push(product);
    }
    products = products.map((product) => {
      return {
        uid: product.id,
        quantity: product.quantity,
        options: product.item_selection,
        price_options: product.price_options,
        selection_options: product.selection_options,
      };
    });
    return products;
  };

  async onConfirm() {
    if (Property.getCartItem().length === 0) {
      this.setState({ showEmptyBasket: true, loading: false, okDisabled: false });
      return;
    }
    const paymentInfo = Property.getPayment();
    const returnUrl = window.location.href;
    const language = this.props.i18n.language;
    let { uid, type } = Property.getOrderInfo();
    const notes = Property.getNoteItemSelection();
    const notesSelectionOptions = Property.getArraySelectionOption();
    const roomLastName = Property.getRoomLastName();
    const options = this.orderSelectedPickOptions();

    if (
      isNull(paymentInfo) &&
      Property.getStoreInterfaceType() === "adyen" &&
      Property.getPaymentSelected() === "adyen"
    ) {
      /// ADYEN DROP-IN -------------------------------------------------------
      this.setState({ loading: true, okDisabled: true });
      const { products, arraySelector, lastName, roomNumber } = this.state;
      const orderProducts = products.map((product) => {
        return {
          uid: product.id,
          quantity: product.quantity,
          price: product.price,
          price_options: product.price_options,
        };
      });
      const tokenResponse = await TokenService.getProperty(
        Property.getData().uid
      );
      const accessToken = get(tokenResponse.data, "access_token");

      getAdyenSessionData(
        uid,
        type,
        orderProducts,
        this.orderSelectedPickOptions(arraySelector),
        returnUrl,
        roomNumber || roomLastName.roomNumber,
        lastName || roomLastName.lastName,
        accessToken,
        notes
      )
        .then(
          function (result) {
            if (result.status === false) {
              this.setState({
                hasError: true,
                getPriceErrorMessage: result.error,
                loading: false,
                okDisabled: false,
              });
            } else {
              Property.setPaymentId(result);
              Property.setRoomLastName({ lastName, roomNumber });
              Property.setPaymentTransaction(result.payment_transaction);
              this.props.history.push({
                pathname: "/dropin",
                state: {
                  sessionData: result.session,
                  total: this.state.total,
                  extraCharges: this.state.extraCharges,
                  adyenEnv: result.environment,
                  clientKey: result.client_key,
                },
              });
            }
          }.bind(this)
        )
        .catch((err) => {
          console.error(err);
          this.setState({
            hasError: true,
            getPriceErrorMessage: `${this.props.t("NETWORK_ERROR")}`,
          });
        });
      /// ADYEN DROP-IN -------------------------------------------------------
    } else if (
      isNull(paymentInfo) &&
      Property.getStoreInterfaceType() === "hotelkey"
    ) {
      /// hotelkey -------------------------------------------------------
      this.setState({ loading: true, okDisabled: true });
      const { lastName, roomNumber } = this.state;
      const propertyUid = Property.getData().uid;
      const platform = Property.getPlatform() || "web_store";
      const deviceType = Property.getDeviceType();

      const roomLastName = Property.getRoomLastName();
      const tokenResponse = await TokenService.getProperty(propertyUid);
      const accessToken = get(tokenResponse, "data.access_token");
      ReservationService.getReservation(
        propertyUid,
        lastName || roomLastName.lastName,
        roomNumber || roomLastName.roomNumber,
        language,
        accessToken
      )
        .then(
          function (result) {
            if (result.status === false) {
              this.setState({
                hasError: true,
                getPriceErrorMessage: result.error,
                loading: false,
                okDisabled: false,
              });
            } else {
              Property.setReservation(result.data);
              const email = get(result.data, "payment_link_payer_email");
              const products = this.getAllProducts();
              const reservationId = get(result.data, "reservation_id");
              const name = get(result.data, "payment_link_payer_name");
              const data = {
                uid: propertyUid,
                hotelkey_payment_link: {
                  non_cart: {
                    uid,
                    notes,
                    products,
                    platform,
                    pick_options: options,
                    room_number: roomNumber,
                    last_name: lastName,
                    reservation_id: reservationId,
                    payment_link_payer_name: name,
                    payment_link_payer_email: email,
                    notes_selection_options: notesSelectionOptions,
                    fulfillment: {
                      fulfillment_type_name: type,
                      device_type: deviceType,
                    },
                  },
                  reservation_id: reservationId,
                  payment_link_payer_name: name,
                  payment_link_payer_email: email,
                },
                booking: {
                  email: email,
                },
              };
              PaymentService.postHotelKeyPaymentLink(accessToken, data)
                .then(
                  function (result) {
                    const jobId = get(result.data, "job_id");
                    this.hotelKeyStatus(accessToken, jobId, email);
                  }.bind(this)
                )
                .catch((error) => {
                  console.error(error);
                  this.setState({
                    hasError: true,
                    loading: false,
                    okDisabled: false,
                    getPriceErrorMessage:
                      get(error.response, "data.error") ||
                      `${this.props.t("NETWORK_ERROR")}`,
                  });
                  return;
                });
            }
          }.bind(this)
        )
        .catch((error) => {
          console.error(error);
          this.setState({
            hasError: true,
            loading: false,
            okDisabled: false,
            getPriceErrorMessage:
              get(error.response, "data.error") ||
              `${this.props.t("NETWORK_ERROR")}`,
          });
          return;
        });
    } else {
      const cartItem = Property.getCartItem();
      const autoReminder = cartItem.autoReminder;
      const products = this.getAllProducts();
      const expireKey = Property.getExpireKey();
      const accessToken = Property.getAccessToken();
      const platform = Property.getPlatform();
      const deviceType = Property.getDeviceType();
      const { lastName, roomNumber } = this.state;
      const roomLastName = Property.getRoomLastName();
      const paymentSelected = Property.getPaymentSelected();
      const paymentId = get(paymentInfo, "id", "");
      this.setState({ loading: true, okDisabled: true }, () => {
        postFulfillmentOrders(
          uid,
          type,
          products,
          expireKey,
          notes,
          notesSelectionOptions,
          lastName || roomLastName.lastName,
          roomNumber || roomLastName.roomNumber,
          language,
          accessToken,
          platform,
          deviceType,
          paymentId,
          paymentSelected,
          autoReminder,
          options
        )
          .then(
            function (result) {
              if (result && result.error_message) {
                this.setState({
                  showConfirmation: false,
                  loading: false,
                  lastName: "",
                  roomNumber: "",
                  okDisabled: false,
                  hasError: true,
                  postOrderErrorMessage: result.error_message,
                });
              } else {
                this.setState({
                  showConfirmation: false,
                  loading: false,
                  lastName: "",
                  roomNumber: "",
                  okDisabled: false,
                  postOrderErrorMessage: "",
                });
                Property.setOrderSuccess(result);
                Property.clearCartItem();
                Property.clearPayment();
                if (!isNull(Property.getAccessToken())) {
                  this.redirectMobile();
                } else if (this.isStoreClubEvent()) {
                  this.setState({ showConfirmation: true });
                } else {
                  this.props.history.push("/success");
                }
              }
            }.bind(this)
          )
          .catch((err) => {
            console.log(err);
            const err_msg =
              get(err, "response.data.error_message") ||
              this.props.t("NETWORK_ERROR");
            const isNoProducts = get(err, "response.data.error_message") === "No products";

            this.setState({
              hasError: true,
              postOrderErrorMessage: err_msg,
              loading: false,
              lastName: "",
              roomNumber: "",
              okDisabled: false,
              redirectAfterError: isNoProducts,
            });
            Property.clearPayment();
          });
      });
    }
  }

  redirectMobile() {
    if (window.ReactNativeWebView) {
      window.ReactNativeWebView.postMessage("navigation_back_my_request");
    } else {
      this.props.history.push("/success");
    }
  }

  orderSelectedPickOptions(currentArraySelector) {
    let priceOptions = [];
    currentArraySelector = currentArraySelector || this.state.arraySelector;
    currentArraySelector.forEach((select) => {
      let prices = [];
      if (select.selection_type === "pick_one_price") {
        select.values.forEach((option) => {
          if (option.select) {
            prices.push({ amount: option.price, quantity: 1 });
          }
        });
        if (!isEmpty(prices)) {
          priceOptions = [
            ...priceOptions,
            { type: select.selection_type, prices: [...prices] },
          ];
        }
      } else if (select.selection_type === "pick_product_price") {
        select.values.forEach((option) => {
          if (option.value && option.value > 0) {
            prices.push({ amount: option.price, quantity: option.value, select: true });
          }
        });
        if (!isEmpty(prices)) {
          priceOptions = [
            ...priceOptions,
            { type: select.selection_type, prices: [...prices] },
          ];
        }
      }
    });
    return priceOptions;
  }

  editPressed() {
    if (this.state.edit) {
      this.updateBasket();
      this.setState({ edit: false });
    } else {
      this.setState({ edit: true });
    }
  }

  updateBasket() {
    let { uid, type } = Property.getOrderInfo();
    let orderProducts = this.state.products.map((product) => {
      return {
        uid: product.id,
        quantity: product.quantity,
        price_options: product.price_options,
      };
    });

    if (orderProducts.length === 0) {
      this.setState({
        extraCharges: [],
        lastExtraCharges: [],
        total: 0,
        subtotal: 0,
      });
    } else {
      getFulfillmentPrices(
        uid,
        type,
        orderProducts,
        this.orderSelectedPickOptions()
      )
        .then(
          function (result) {
            if (result && result.error_message) {
              this.setState({
                hasError: true,
                getPriceErrorMessage: result.error_message,
              });
            } else {
              const total = result.total;
              const subtotal = result.subtotal;
              const extraCharges = result.extra_charges;
              const roomUser = result.room;
              this.setState({
                extraCharges,
                total,
                subtotal,
                lastExtraCharges: result.last_extra_charges,
                getPriceErrorMessage: "",
                disabledBottomBar: false,
                roomUser,
                hasError: result.force_update,
                WarningMessage: result.force_update
                  ? this.props.t("WARNING_MESSAGE_UPDATE_PRODUCT")
                  : "",
              });
            }
          }.bind(this)
        )
        .catch(() => {
          this.setState({
            hasError: true,
            getPriceErrorMessage: this.props.t("NETWORK_ERROR"),
          });
        });
      Property.setArraySelectionOption(this.state.arraySelector);
    }
  }

  needCheckRoomNumber() {
    const expireKey = Property.getExpireKey();
    const accessToken = Property.getAccessToken();
    if (Property.getPaymentSelected() === "bill_to_room") {
      return !(!isNull(accessToken) || (expireKey && this.state.roomUser));
    }
    const pairedUser = Property.getPairingUserStatus();
    if (pairedUser) {
      return false;
    } else {
      const products = this.state.products;
      const store_available_unpaired = Property.getStoreUnpairedAvailable();
      if (store_available_unpaired) {
        return false;
      }
      const productAvailableForUnpaired = filter(products, (p) => {
        return p.unpaired_available || p.category_unpaired_available;
      });
      const allAvailableForUnpaired = productAvailableForUnpaired.length;
      if (products.length === allAvailableForUnpaired) {
        return false;
      }
    }

    if (!isNull(accessToken) && accessToken !== '') {
      return false;
    } else if (expireKey && this.state.roomUser) {
      return false;
    } else {
      return true;
    }
  }

  modalErrorStatus(modalStatus) {
    const { uid, type } = Property.getOrderInfo();
    const { products } = this.state;
    const orderProducts =
      products &&
      products.map((product) => {
        return {
          uid: product.id,
          quantity: product.quantity,
          updated_at: product.updatedAt,
          price_options: product.price_options,
        };
      });
    this.setState({ hasError: modalStatus });
    if (!modalStatus && this.state.redirectAfterError) {
      this.setState({ redirectAfterError: false });
      const productUrl = Property.getProductURL();
      if (productUrl) {
        this.props.history.push(productUrl);
      } else {
        this.props.history.goBack();
      }
      return;
    }
    if (
      orderProducts.length !== 0 &&
      this.state.getPriceErrorMessage !== "" &&
      modalStatus
    ) {
      getFulfillmentPrices(
        uid,
        type,
        orderProducts,
        this.orderSelectedPickOptions()
      )
        .then(
          function (result) {
            if (result && result.error_message) {
              this.setState({
                hasError: true,
                getPriceErrorMessage: result.error_message,
              });
            } else {
              const total = result.total;
              const subtotal = result.subtotal;
              const extraCharges = result.extra_charges;
              const roomUser = result.room;
              this.setState({
                extraCharges,
                total,
                subtotal,
                lastExtraCharges: result.last_extra_charges,
                getPriceErrorMessage: "",
                disabledBottomBar: false,
                roomUser,
                hasError: result.force_update,
                WarningMessage: result.force_update
                  ? this.props.t("WARNING_MESSAGE_UPDATE_PRODUCT")
                  : "",
              });
            }
          }.bind(this)
        )
        .catch(() => {
          this.setState({
            hasError: true,
            getPriceErrorMessage: this.props.t("NETWORK_ERROR"),
          });
        });
    }
    if (
      orderProducts.length !== 0 &&
      this.state.warningMessage !== "" &&
      !modalStatus
    ) {
      if (
        this.state.warningMessage ===
        this.props.t("WARNING_MESSAGE_UPDATE_PRODUCT")
      ) {
        Property.clearCartItem();
      }
      const redirectToHome =
        this.state.warningMessage ===
        this.props.t("WARNING_MESSAGE_UPDATE_PRODUCT");
      this.setState({
        warningMessage: "",
      });
      const webStoreHomePage = Property.getWebStoreHomePage();
      if (webStoreHomePage && redirectToHome)
        window.location.href = webStoreHomePage;
    }
  }

  confirmationModalView() {
    if (!this.state.showConfirmation) {
      return;
    }
    Property.setArraySelectionOption(this.state.arraySelector);
    const currencyCode = Property.getCurrencyCode();
    if (this.isStoreClubEvent()) {
      return (
        <SimpleModal
          showCloseIcon
          showConfirmation={this.state.showConfirmation}
          openCloseModal={(showConfirmation) => {
            this.setState({ showConfirmation });
            const pUid = this.state.propertyUid;
            const sUid = this.state.storeUid;
            this.props.history.push(`/store?puid=${pUid}&uid=${sUid}`);
          }}
          content={this.props.t("THAT_IS_ALL_SEE_YOU_THERE")}
        />
      );
    } else if (this.needCheckRoomNumber()) {
      const { lastName, roomNumber, okDisabled, total, showConfirmation } =
        this.state;
      let btnOkDisable = okDisabled;
      if ((isEmpty(lastName) || isEmpty(roomNumber)) && !okDisabled) {
        btnOkDisable = true;
      }

      return (
        <ConfirmOrderAskRoomLastNameModal
          showConfirmation={showConfirmation}
          openCloseModal={(showConfirmation) =>
            this.setState({ showConfirmation })
          }
          onConfirm={() => this.onConfirm()}
          total={`${currencyCode} ${total}`}
          loading={false}
          onChange={this.onChange}
          okDisabled={btnOkDisable}
        />
      );
    } else {
      return (
        <ConfirmationModal
          showConfirmation={this.state.showConfirmation}
          openCloseModal={(showConfirmation) =>
            this.setState({ showConfirmation })
          }
          onConfirm={() => this.onConfirm()}
          total={this.state.total}
          loading={false}
          okDisabled={this.state.okDisabled}
        />
      );
    }
  }

  handleClick() {
    Property.setArraySelectionOption(this.state.arraySelector);
    Property.popPreviousTitle();
  }

  isStoreClubEvent() {
    return this.state.fulfillmentTypeName === "club_events";
  }
  render() {
    const {
      lastExtraCharges,
      extraCharges,
      preset,
      disabledBottomBar,
      noticePaymentMethod,
    } = this.state;
    const products = this.state.products;
    const currencyCode = Property.getCurrencyCode();
    const productUrl = Property.getProductURL();
    const title = Property.getPreviousTitle();
    const { categoryId } = this.props.match.params;
    let errorMessage = "";
    let btnErrorText = "";
    let modalTitle = this.props.t("ERROR");
    if (this.state.getPriceErrorMessage !== "") {
      errorMessage = this.state.getPriceErrorMessage;
      btnErrorText = this.props.t("RETRY");
    } else if (this.state.postOrderErrorMessage !== "") {
      errorMessage = this.state.postOrderErrorMessage;
      btnErrorText = this.props.t("OK");
    } else if (this.state.dateTimeErrorMessage !== "") {
      errorMessage = this.state.dateTimeErrorMessage;
      btnErrorText = this.props.t("OK");
    } else if (this.state.WarningMessage !== "") {
      errorMessage = this.state.WarningMessage;
      btnErrorText = this.props.t("OK");
      modalTitle = this.props.t("IMPORTANT_NOTICE");
    }

    return (
      <div>
        <TopBar
          title={this.props.t("TOP_BAR")}
          previousTitle={title ? title : undefined}
          previousUrl={`/categories/${categoryId}/products`}
          currentPage={"basketStore"}
        />
        <TopPadding className="lg:hidden" />
        {this.confirmationModalView()}
        {this.state.showEmptyBasket ? (
          <SimpleModal
            showCloseIcon
            showConfirmation={this.state.showEmptyBasket}
            openCloseModal={() => {
              this.setState({ showEmptyBasket: false });
              const productUrl = Property.getProductURL();
              if (productUrl) {
                this.props.history.push(productUrl);
              } else {
                this.props.history.goBack();
              }
            }}
            content={this.props.t("EMPTY_BASKET")}
          />
        ) : null}
        {this.state.hasError ? (
          <ErrorModal
            stateModal={this.state.hasError}
            openCloseModal={(modalStatus) => this.modalErrorStatus(modalStatus)}
            textTitle={modalTitle}
            btnErrorText={btnErrorText}
            childText={errorMessage}
          />
        ) : null}
        {this.state.requiredField ? (
          <FillRequiredModal
            stateModal={this.state.requiredField}
            openCloseModal={(stateModal) =>
              this.setState({ requiredField: stateModal })
            }
          />
        ) : null}
        <Container
          className={"sectionContent"}
          id="list-container">
          <Flex
            container
            flex={1}
            margin="24px"
            alignItems="center"
            justifyContent="space-between">
            <TitleOrder
              className={"headerText"}
              app_home_menu_category={preset.app_home_menu_category}>
              {this.props.t("YOUR_ORDER").toLowerCase()}
            </TitleOrder>
            <Button
              app_home_color_primary={preset.app_home_color_primary}
              app_home_text_top_nav={preset.text_color}
              onClick={() => this.editPressed()}>
              {this.state.edit ? this.props.t("DONE") : this.props.t("EDIT")}
            </Button>
          </Flex>
          <hr />
          {products.map((item, index) => (
            <Flex key={index}>
              <Flex
                container
                margin="16px 16px"
                alignItems={"flex-start"}>
                {this.state.edit ? (
                  <Flex
                    container
                    alignItems={"center"}
                    width={"75px"}
                    justifyContent={"center"}>
                    {!find(item.price_options, (data) => {
                      return data.type === "pick_product_price";
                    }) && (
                      <div
                        onClick={() =>
                          this.editCart("minus", item.id, item.item_selection)
                        }>
                        <RemoveCircle
                          style={{ fontSize: 25, marginRight: 8 }}
                        />
                      </div>
                    )}
                    <TextQuantity>{item.quantity}</TextQuantity>
                    {!find(item.price_options, (data) => {
                      return data.type === "pick_product_price";
                    }) &&
                      !find(item.selection_options, (data) => {
                        return (
                          [
                            "hourly_product",
                            "fixed_inventory_selection",
                          ].includes(data.type) &&
                          this.state.enableInventoryManagement
                        );
                      }) && (
                        <div
                          onClick={() =>
                            this.editCart("plus", item.id, item.item_selection)
                          }>
                          <AddCircle style={{ fontSize: 25, marginLeft: 8 }} />
                        </div>
                      )}
                  </Flex>
                ) : (
                  <ButtonQuantity
                    app_home_text_top_nav={preset.text_color}
                    app_home_color_secondary={preset.app_home_color_secondary}>
                    {item.quantity + "x"}
                  </ButtonQuantity>
                )}
                <Flex
                  flex={1}
                  margin="0 0 0 16px"
                  className={"itemListDescription"}>
                  <TitleProduct
                    className={"itemListText"}
                    app_home_menu_category={preset.app_home_menu_category}>
                    {item.title.toLowerCase()}
                  </TitleProduct>
                  <SubTitleProduct
                    className={"itemListTextSelection"}
                    app_home_text_body_secondary={
                      preset.app_home_text_body_secondary
                    }>
                    {item.item_selection}
                  </SubTitleProduct>
                  <Flex
                    container
                    justifyContent="flex-end"
                    margin={"0 16px 0 0"}>
                    <SubTitleProduct
                      className={"priceContainer"}
                      app_home_text_body_secondary={
                        preset.app_home_text_body_secondary
                      }>
                      {Intl.NumberFormat(currencyCode, {
                        style: "currency",
                        currency: currencyCode,
                        currencyDisplay: "code",
                      }).format(item.totalPrice)}
                    </SubTitleProduct>
                  </Flex>
                </Flex>
                {this.state.edit ? (
                  <Flex>
                    <CloseIcon
                      style={{ fontSize: "25px", color: "gray" }}
                      onClick={() =>
                        this.removeItem(item.id, item.item_selection)
                      }
                    />
                  </Flex>
                ) : (
                  <></>
                )}
              </Flex>
              <hr />
            </Flex>
          ))}
          {!this.isStoreClubEvent() && (
            <>
              <Flex
                container
                flex={1}
                margin={"16px 0"}
                alignItems={"center"}
                justifyContent={"center"}>
                <Link
                  to={{ pathname: `${productUrl}` }}
                  onClick={this.handleClick.bind(this)}>
                  <ButtonComponent
                    fontSize={"20px"}
                    disabled={this.state.edit}
                    label={this.props.t("ADD_MORE_ORDER")}
                    backgroundColor={preset.app_home_color_primary}
                    borderRadius={"30px"}
                    color={preset.text_color}
                  />
                </Link>
              </Flex>

              <hr />
            </>
          )}
          {this.state.arraySelector.map((item, index) => {
            const visibleOption = ![
              "location_selection",
              "room_number_selection",
            ].includes(item.selection_type);
            if (visibleOption) {
              return (
                <Flex
                  container
                  flex={1}
                  margin={"16px 0"}
                  key={index}>
                  <Selector
                    selectionType={item.selection_type}
                    item={item}
                    index={index}
                    onChange={(event) => {
                      let arraySelector = this.state.arraySelector;
                      arraySelector[index].values = event.target.value;
                      this.setState({ arraySelector });
                    }}
                    refreshData={(data, id) =>
                      this.refreshArraySelector(data, id)
                    }
                    checkValidation={this.state.checkValidation}
                  />
                </Flex>
              );
            }
            return "";
          })}

          <Flex
            flex={1}
            container
            margin={"16px 16px"}
            justifyContent={"space-between"}>
            <TagPrice
              className={"priceText"}
              app_home_list_item_subtitle_color={
                preset.app_home_list_item_subtitle_color
              }>
              {this.props.t("SUBTOTAL")}
            </TagPrice>
            <TagPrice
              className={"priceText"}
              app_home_list_item_subtitle_color={
                preset.app_home_list_item_subtitle_color
              }>
              {Intl.NumberFormat(currencyCode, {
                style: "currency",
                currency: currencyCode,
                currencyDisplay: "code",
              }).format(this.state.subtotal)}
            </TagPrice>
          </Flex>
          {extraCharges &&
            extraCharges.map((item, index) => (
              <Flex
                flex={1}
                container
                margin={"16px 16px"}
                justifyContent={"space-between"}
                key={index}>
                <TagPrice
                  className={"priceText"}
                  app_home_list_item_subtitle_color={
                    preset.app_home_list_item_subtitle_color
                  }>
                  {item.title +
                    "(" +
                    item.value +
                    (item.type === "percent" ? "%" : ` ${currencyCode}`) +
                    ")"}
                </TagPrice>
                <TagPrice
                  className={"priceText"}
                  app_home_list_item_subtitle_color={
                    preset.app_home_list_item_subtitle_color
                  }>
                  {Intl.NumberFormat(currencyCode, {
                    style: "currency",
                    currency: currencyCode,
                    currencyDisplay: "code",
                  }).format(item.amount)}
                </TagPrice>
              </Flex>
            ))}
          {lastExtraCharges &&
            lastExtraCharges.map((item, index) => (
              <Flex
                flex={1}
                container
                margin={"16px 16px"}
                justifyContent={"space-between"}
                key={index}>
                <TagPrice
                  className={"priceText"}
                  app_home_list_item_subtitle_color={
                    preset.app_home_list_item_subtitle_color
                  }>
                  {item.title +
                    "(" +
                    item.value +
                    (item.type === "percent" ? "%" : ` ${currencyCode}`) +
                    ")"}
                </TagPrice>
                <TagPrice
                  className={"priceText"}
                  app_home_list_item_subtitle_color={
                    preset.app_home_list_item_subtitle_color
                  }>
                  {Intl.NumberFormat(currencyCode, {
                    style: "currency",
                    currency: currencyCode,
                    currencyDisplay: "code",
                  }).format(item.amount)}
                </TagPrice>
              </Flex>
            ))}

          <Flex
            flex={1}
            container
            margin={"32px 16px"}
            justifyContent={"space-between"}>
            <TotalPrice
              className={"priceText"}
              app_home_menu_category={preset.app_home_menu_category}>
              {this.props.t("TOTAL")}
            </TotalPrice>
            <TotalPrice
              className={"priceText"}
              app_home_menu_category={preset.app_home_menu_category}>
              {Intl.NumberFormat(currencyCode, {
                style: "currency",
                currency: currencyCode,
                currencyDisplay: "code",
              }).format(this.state.total)}
            </TotalPrice>
          </Flex>
          {Property.getStoreInterfaceType() === "adyen" && (
            <PaymentMethod
              handler={this.handlerPaymentMethod.bind(this)}
              notification={noticePaymentMethod}
            />
          )}
          <LoadingScreen loadingState={this.state.loading} />
        </Container>
        {!isNull(Property.getPairGuest()) &&
        !Property.getPairGuest() &&
        0 === products.length ? (
          <BottomBar
            title={this.props.t("PREVIOUS_MENU")}
            handler={this.handlerPreviousMenu.bind(this)}
          />
        ) : (
          <BottomBar
            disabled={this.state.edit || disabledBottomBar || this.state.loading || this.state.okDisabled}
            title={`${this.props.t(
              !this.isStoreClubEvent()
                ? "PLACE_ORDER"
                : "CLUB_EVENT_SAVE_YOUR_SPOT"
            )} ${Intl.NumberFormat(currencyCode, {
              style: "currency",
              currency: currencyCode,
              currencyDisplay: "code",
            }).format(this.state.total)}`}
            handler={
              this.isStoreClubEvent()
                ? this.saveSpot
                : this.state.placeOrderCheck
                ? this.showModal
                : this.doNothing
            }
          />
        )}
      </div>
    );
  }
}

export default withTranslation()(BasketStore);
